export default __webpack_public_path__ + "static/media/Gallery-15.132ae2eb.jpeg";